import { CircleInfo } from "@safetyculture/icons-react";
import { InfoOnHoverWrapper, StyledTooltip } from "./styles.css";

interface Props {
  msg: string;
}

const InfoTooltip: React.FC<Props> = ({ msg }) => {
  return (
    <StyledTooltip label={msg} delay={{ close: 300 }}>
      <InfoOnHoverWrapper>
        <CircleInfo size={18} color="inherit" />
      </InfoOnHoverWrapper>
    </StyledTooltip>
  );
};

export default InfoTooltip;
